import React, { useEffect } from 'react'
import { useAtom, useAtomValue, useSetAtom } from 'jotai'
import { useTranslation } from 'react-i18next'
import { Box } from '@node-space/ui-components'
import { useWalletActionContext } from 'pages/Wallets/context/WalletSheetProvider'
import { SendStep } from 'types/walletActions'
import { estimateIdAtom, sendStepAtom } from './atoms/atoms'
import { SendApproval } from './SendApproval'
import { SendComplete } from './SendComplete'
import { SendContact } from './SendContact'
import { SendDetails } from './SendDetails'
import { SendReview } from './SendReview'

const sendSteps = [
  SendStep.CONTACT,
  SendStep.DETAILS,
  SendStep.REVIEW,
  SendStep.COMPLETE,
  SendStep.APPROVAL,
] as const

export const Send = () => {
  const { t } = useTranslation()
  const step = useAtomValue(sendStepAtom)
  const [sendStep, setSendStep] = useAtom(sendStepAtom)
  const setEstimateId = useSetAtom(estimateIdAtom)
  const [walletAction, setWalletAction] = useWalletActionContext()

  const isFormSteps =
    sendStep !== SendStep.COMPLETE &&
    sendStep !== SendStep.CONTACT &&
    sendStep !== SendStep.APPROVAL

  const getSheetHeader = (): string => {
    switch (sendStep) {
      case SendStep.CONTACT:
        return t('wallets.send.contactStepHeader')
      case SendStep.DETAILS:
        return t('wallets.send.detailsStepHeader')
      case SendStep.REVIEW:
        return t('wallets.send.reviewStepHeader')
      default:
        return ''
    }
  }

  const handleOnBack = () => {
    const currentStepIndex = sendSteps.indexOf(sendStep)
    if (sendStep === SendStep.REVIEW || sendStep === SendStep.DETAILS) {
      setEstimateId(null)
    }
    setSendStep(sendSteps[currentStepIndex - 1])
  }

  useEffect(() => {
    setWalletAction({
      ...walletAction,
      header: getSheetHeader(),
      ...(isFormSteps ? { onBack: handleOnBack } : { onBack: undefined }),
    })
  }, [sendStep, isFormSteps])

  return (
    <Box width="full">
      {step === SendStep.CONTACT && <SendContact />}
      {step === SendStep.DETAILS && <SendDetails />}
      {step === SendStep.REVIEW && <SendReview />}
      {step === SendStep.COMPLETE && <SendComplete />}
      {step === SendStep.APPROVAL && <SendApproval />}
    </Box>
  )
}
